var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-columns',{attrs:{"is-multiline":""}},_vm._l((_vm.agentSymptoms),function(symptom,idx){return _c('b-column',{key:idx,staticClass:"is-half-desktop"},[_c('agent-symptom-card',{attrs:{"symptom":symptom.symptom,"treatments":symptom.treatments}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }